import React from 'react'
import {
    Create,
    SimpleForm,
    TextInput,
    ReferenceInput,
    SelectInput,
    BooleanInput,
    NumberInput,
} from 'react-admin'


export const SistemaElectricoCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput source="id"/>
            <TextInput source="name" />
            <TextInput source="subsystem_name" />
            <TextInput source="subsystem_code" />
            <BooleanInput source="active" />
            <ReferenceInput source="sistema_interconectado" reference="sistemas-interconectados">
                <SelectInput source="name" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);
